import { render, staticRenderFns } from "./input-with-confirmation.vue?vue&type=template&id=72bdf580&scoped=true"
import script from "./input-with-confirmation.vue?vue&type=script&lang=js"
export * from "./input-with-confirmation.vue?vue&type=script&lang=js"
import style0 from "./input-with-confirmation.vue?vue&type=style&index=0&id=72bdf580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bdf580",
  null
  
)

export default component.exports